import { useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Panel } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export function EmailChangePanel() {
  const { user, setUser } = useAuth();
  const [f, setF] = useState({ new_email: "", password: "" });
  const [sentTo, setSentTo] = useState("");
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async (fn) => { setBusy(true); try { await fn(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); } };
  const request = (e) => { e.preventDefault(); run(async () => { const { data } = await api.post("/me/email/request", f); setSentTo(data.email); toast.success(`Codice inviato a ${data.email}`); }); };
  const confirm = (e) => {
    e.preventDefault();
    run(async () => {
      const { data } = await api.post("/me/email/confirm", { code });
      setUser?.(data);
      toast.success("Indirizzo email aggiornato");
      setSentTo(""); setCode(""); setF({ new_email: "", password: "" });
    });
  };
  return (
    <Panel title="Indirizzo email" testId="email-change-panel">
      <div className="space-y-4 p-5">
        <p className="flex items-center gap-2 text-sm"><Mail className="h-4 w-4 text-primary" />Attuale: <span className="font-medium" data-testid="email-current">{user.email}</span></p>
        {!sentTo ? (
          <form onSubmit={request} className="grid gap-3 sm:grid-cols-[1fr_1fr_auto] sm:items-end">
            <div className="space-y-1.5"><Label>Nuovo indirizzo email</Label><Input type="email" value={f.new_email} onChange={(e) => setF({ ...f, new_email: e.target.value })} required data-testid="email-new-input" /></div>
            <div className="space-y-1.5"><Label>Password attuale</Label><Input type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required autoComplete="current-password" data-testid="email-password-input" /></div>
            <Button type="submit" disabled={busy} data-testid="email-request-button">Invia codice</Button>
          </form>
        ) : (
          <form onSubmit={confirm} className="space-y-3">
            <p className="text-sm text-muted-foreground">Abbiamo inviato un codice di 6 cifre a <span className="font-medium text-foreground">{sentTo}</span>. Inseriscilo per confermare.</p>
            <div className="flex flex-wrap gap-2">
              <Input className="w-40 text-center font-mono tracking-[0.3em]" inputMode="numeric" maxLength={6} value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} required data-testid="email-code-input" />
              <Button type="submit" disabled={busy || code.length !== 6} data-testid="email-confirm-button">Conferma</Button>
              <Button type="button" variant="ghost" onClick={() => { setSentTo(""); setCode(""); }} data-testid="email-change-cancel">Annulla</Button>
            </div>
          </form>
        )}
      </div>
    </Panel>
  );
}
